import { Box, Grid, Heading, InlineStack, Panel, PanelSection } from '@customerio/pluma-components/react';
import { useSqlImportDatabases } from '@/services/db/sql-import-database/queries';
import { useSqlImportRows } from '@/services/db/sql-import-row/queries';
import { SQL_DATABASE_CATALOG } from '@/features/sql-sync';
import { SyncStatusBadge } from '../../components/sync-status-badge';
import { useSqlImportDetail } from '../context';
import { rowsRefetchIntervalMs } from '../rows';
import { ImportConfiguration } from '../components/import-configuration';
import { ImportRows } from '../components/import-rows';
import { useSqlImportTabViewTracking } from '../use-tab-view-tracking';

/** The Imports tab: the run history, with the configuration beside it. */
export function RunsTab() {
  useSqlImportTabViewTracking('importsTabViewed');

  const { workspaceId, type, sqlImportId, sqlImport, objectTypes, syncTarget, segment, canEdit, hrefs } =
    useSqlImportDetail();
  const workspace = Number(workspaceId);
  const { data: databases } = useSqlImportDatabases({ type, workspaceId: workspace });
  const { data: rows } = useSqlImportRows({
    importId: sqlImportId,
    workspaceId: workspace,
    queryConfig: { refetchInterval: (query) => rowsRefetchIntervalMs(query.state.data) },
  });

  const database = databases.find((candidate) => candidate.id === sqlImport.database_id);
  const segmentNames = new Map(segment == null ? [] : [[segment.id, segment.name] as const]);

  return (
    <Grid columns={3} gap="200" alignItems="flex-start">
      <Box style={{ gridColumn: 'span 2' }}>
        <Panel>
          <PanelSection>
            <InlineStack gap="100" alignBlock="center">
              <Heading level="3">{SQL_DATABASE_CATALOG[type].name} Import</Heading>
              <SyncStatusBadge sqlImport={sqlImport} />
            </InlineStack>
          </PanelSection>
          <ImportRows
            workspaceId={workspace}
            type={type}
            sqlImport={sqlImport}
            database={database}
            rows={rows}
            objectTypes={objectTypes}
            segmentNames={segmentNames}
            isReadOnly={!canEdit}
          />
        </Panel>
      </Box>
      <Panel>
        <PanelSection>
          <ImportConfiguration
            workspaceId={workspaceId}
            sqlImport={sqlImport}
            database={database}
            syncTarget={syncTarget}
            segment={segment}
            canEdit={canEdit}
            settingsHref={hrefs.settings}
          />
        </PanelSection>
      </Panel>
    </Grid>
  );
}
